<template>
  <div>
    <div v-if="!isAuthenticationGranted">
      <!-- nic nezobrazit -->
    </div>
    <div v-if="isAuthenticationGranted" class="header_user">
      <span style="text-wrap: nowrap"><b-icon icon="person-fill"></b-icon> {{ userName }} </span>
    </div>
  </div>
</template>

<script>
import router from "../router/index";

export default {
  name: "UserControlNia",
  data() {
    return {
      isTestovaci: false,
      isAuthenticationGranted: null,
      userName: "",
    };
  },
  methods: {
    // Log the user in
      login() {
          if (this.isTestovaci)
              router.push("/" + this.$customerUuid + "/testlogin");
          else
              router.push("/" + this.$customerUuid + "/login");
      },
    checkAuthentication() {
      this.$backend.getAuthenticationStatus(response => {
        this.isAuthenticationGranted = this.$utils.isAuthenticationGranted(response);
      });
    },
    setUserDetails(response) {
      this.userName = response.data.firstName + " " + response.data.familyName;
    },
    setIsTestovaci(response) {
        this.isTestovaci = this.$utils.isResponseBooleanTrue(response);
    },
  },
  mounted() {
    this.checkAuthentication();
    this.$backend.getAuthnetictedUser(response =>
      this.setUserDetails(response),
    );
    this.$backend.isTestovaciSLoginem(response => this.setIsTestovaci(response));
  },
};
</script>
